import { Injectable } from '@angular/core';
import { UserInfo } from 'src/app/models/userInfo';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

	private _userInfo!: UserInfo;
	
	constructor() { 
		this.loadUserInfo();
	}
	
	private saveUserInfo(): void {
		localStorage.setItem('user-info', JSON.stringify(this.userInfo));
	}

	private createUserInfo(): UserInfo {
		return {
			cookiePolicyAccepted: null
		};		
	}

	private  loadUserInfo() {
		let result = localStorage.getItem('user-info');
		if (result) {
			this._userInfo = JSON.parse(result);
		}
		else {
			this._userInfo = this.createUserInfo();
		}
	}

	public get userInfo(): UserInfo {
		return this._userInfo;
	}

	public acceptCookiePolicy() {		
		this._userInfo.cookiePolicyAccepted = true;
		this.saveUserInfo();
	}

	public rejectCookiePolicy() {
		this._userInfo.cookiePolicyAccepted = false;
		this.saveUserInfo();
	}
}
